import Vue from "vue";
import Moment from "moment";
import VuemomentJS from "vue-momentjs";

const state = {
  countries: [],
  totalCountries: 0
};

const getters = {};

const actions = {
  ADD_PRODUCT_IMAGE: async function({ commit, rootState }, payload) {
    return await Vue.prototype.$axios.post("/products/images", payload).then(
      response => {
        return response;
      },
      err => {
        throw new Error(err);
      }
    );
  },
  UPDATE_PRODUCT_IMAGE: async function({ commit }, payload) {
    return await Vue.prototype.$axios.post("/products/images/" + payload.id, {
      image: payload.image,
      productId: payload.productId
    });
  },
  DELETE_PRODUCT_IMAGE: async function({ commit }, payload) {
    return await Vue.prototype.$axios.delete("products/images/" + payload.id);
  }
};

const mutations = {
  SET_COUNTRIES: (state, countries) => {
    state.countries = countries;
  },
  SET_TOTAL_COUNTRIES: (state, total) => {
    state.totalCountries = total;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
